module.exports = __webpack_public_path__ + "static/media/aceite-shell.100cc8b3.png";